import React from 'react';
import Helmet from 'react-helmet';
import Meta from '../components/posts/Meta'
import Comments from '../components/posts/Comments'
import SEO from '../components/SEO'


export default function Template({data}) {

  const { markdownRemark: post } = data;

  return (
    <div className="markdown--content">

      <SEO data={ post.frontmatter } />

      <header>
        <h1>{ post.frontmatter.title }</h1>
      </header>

      <div dangerouslySetInnerHTML={{ __html: post.html }} />

      <Meta data={ post.frontmatter } />
      <Comments data={ post.frontmatter } />

    </div>
  )
}


export const postQuery = graphql`
    query BlogPostByPath($path: String!) {
      markdownRemark(frontmatter: { path: { eq: $path} }) {
        html
        frontmatter {
          path
          type
          title
          description
          tags
          image
          comments
          date(formatString: "MMMM DD, YYYY [at] hh:mm A")
          updated(formatString: "MMMM DD, YYYY [at] hh:mm A")
        }
      }
    }
  `


/*
          tags
        <p>This article was published on <strong>{ post.frontmatter.date }</strong></p>
*/



// WEBPACK FOOTER //
// ./src/global/templates/post.js